import __request__ from "routing/request";
export function update(authServiceId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/team-sync/services/${authServiceId}/backend`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(authServiceId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/team-sync/services/${authServiceId}/backend`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(authServiceId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.security/team-sync/services/${authServiceId}/backend`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(authServiceId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.security/team-sync/services/${authServiceId}/backend`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getUsers(sort = "name", authServiceId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/team-sync/services/${authServiceId}/backend/teams`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
